/**
 * This file is no longer in use for API configuration.
 * If you need to change configuration data for local or feature branch test bed development,
 * change the values in `src/assets/app-config.json`
 */
export const environment = {
  production: false,
};
